import { useState } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import SmallScreenFounder from "./small";
import LargeScreenFounder from "./large";

const HomePageFounderSection = () => {
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));

  return isSmallScreen ? (
    <SmallScreenFounder expanded={expanded} onToggle={() => setExpanded((e) => !e)} />
  ) : (
    <LargeScreenFounder expanded={expanded} onToggle={() => setExpanded((e) => !e)} />
  );
};

export default HomePageFounderSection;
